<template>
  <v-container class="w-auto mx-15" fluid>
    <v-row align="start" justify="center" class="d-flex align-self-start w-100">
      <v-col>
        <AdminDataTableHeader
            :table-model="tableModel"
            :is-user="true"
            :create-action="createUser"
        />

        <AdminDataTable
          :keys-table-model="KeysTableModel"
          :table-model="tableModel"
          :subject="'u'"
          :view="viewUser"
          :edit="editUser"
          :switchStatus="switchStatusUser"
        >
          <template v-slot:item.u.username="{ item }">
            <v-tooltip location="bottom">
              <template v-slot:activator="{ props }">
                <v-icon
                  class="mr-1"
                  v-bind="props"
                  :color="item.status === USER_STATUSES.BLOCKED.code ? 'rgb(var(--error-color))' : 'rgb(var(--circle-success-color))'"
                >
                  {{ item.status === USER_STATUSES.BLOCKED.code ? 'custom:checkSircleFailed' : 'custom:checkSircleSuccess' }}
                </v-icon>
              </template>
              {{ item.status === USER_STATUSES.BLOCKED.code ? USER_STATUSES.BLOCKED.label : USER_STATUSES.AUTHORIZED.label }}
            </v-tooltip>
            {{ item.username }}
          </template>
        </AdminDataTable>
      </v-col>
    </v-row>
  </v-container>

  <ConfirmDialog ref="confirm" />
</template>

<script>
import api from '@/api';
import { toast } from '@/lib/toast';
import RemoteTableModel from '@/components/RemoteTableModel';
import AdminDataTable from "@/components/AdminDataTable.vue";
import AdminDataTableHeader from "@/components/AdminDataTableHeader.vue";
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import { USER_STATUSES, CONTRAGENT_STATUSES } from '@/lib/statusHelper';
import { USERS_ROLES, isETPAdmin } from '@/lib/user';
import Config from '@/config';

export default {
  components: {AdminDataTableHeader, AdminDataTable, ConfirmDialog},
  data() {
    const currentUser = Config.getUser().opts;
    const AllHeaders = [
      { title: 'Логин', key: 'u.username' },
      { title: 'ФИО', key: 'u.fio' },
      { title: 'Наименование', key: 'c.fullName', visibleFor: [USERS_ROLES.ETP_ADMIN.code] },
      { title: 'Регистрация', key: 'c.accreditation', visibleFor: [USERS_ROLES.ETP_ADMIN.code] },
      { title: 'Роль пользователя', key: 'u.role'},
      { title: 'CRN', key: 'c.inn', visibleFor: [USERS_ROLES.ETP_ADMIN.code] },
      { title: 'Телефон', key: 'u.phone', sortable: false },
      { title: 'Адрес электронной почты', key: 'u.email', sortable: false },
      { title: '', key: 'actions', sortable: false },
    ];
    const tableModel = new RemoteTableModel({
      headers: AllHeaders.filter(header => !header.visibleFor || header.visibleFor.includes(currentUser.role.code)),
      loader(query) {
        return api.get('/admin/users', { query: JSON.stringify(query) });
      },
      options: {
        itemsPerPage: 10,
      },
    });
    return {
      tableModel: tableModel,
      KeysTableModel: tableModel.bind.headers.map(header => header.key),
      currentUser,
      USER_STATUSES,
    };
  },
  methods: {
    viewUser(item) {
      this.$router.push({
        name: isETPAdmin(this.currentUser.role.code) ? 'admin.users.view' : 'users.view',
        params: { id: item.id },
      });
    },
    createUser() {
      this.$router.push({
        name: isETPAdmin(this.currentUser.role.code) ? 'admin.users.create' : 'users.create',
        params: { id: null },
      });
    },
    editUser(item) {
      this.$router.push({
        name: isETPAdmin(this.currentUser.role.code) ? 'admin.users.edit' : 'users.edit',
        params: { id: item.id }
      });
    },
    filterUsers() {
      if (this.$route.query.inn) {
        const filters = [
          {column: 'c.inn', op: '=', value: this.$route.query.inn}
        ];
        if (this.$route.query.kpp) {
          filters.push({column: 'c.kpp', op: '=', value: this.$route.query.kpp})
        }
        if (this.$route.query.ogrn) {
          filters.push({column: 'c.ogrn', op: '=', value: this.$route.query.ogrn})
        }
        this.tableModel.setFilter(filters);
      } else {
        this.tableModel.setFilter(null);
      }
    },
    async switchStatusUser(items, mode) {
      const { u: user, c: contragent } = items;
      let resultDialog = true;

      if (mode === 'blocked') {
        resultDialog = await this.$refs.confirm.open(
          'Блокирование пользователя',
          this.$t(`Вы уверены, что хотите заблокировать пользователя {_1}?`, {'_1': user.username}),
        ); 
      } else if (mode === 'unblocked') {
        resultDialog = await this.$refs.confirm.open(
          'Разблокирование пользователя',
          this.$t(`Вы уверены, что хотите разблокировать пользователя {_1}?`, {'_1': user.username}) + "<br>" +
          (contragent.status === CONTRAGENT_STATUSES.BLOCKED.code
            ? this.$t(`Организация {_1} также будет разблокирована.`, {'_1': contragent.fullName})
            : '')
        );
      }

      if (resultDialog) {
        try {   
          await api.get(`/admin/users/${user.id}/switchStatus`, {'mode': mode});
          this.tableModel.reload();
        } catch (e) {
          toast.error(e.message);
        }
      }
    }
  },
  watch: {
    '$route' : 'filterUsers'
  },
  created() {
    this.filterUsers();
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-field) {
  padding: 0;
  font-family: var(--primary-font-family-name);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  box-shadow: none;
}

:deep(.v-field__input) {
  display: block;
  padding: 0;
  width: 48px;
  height: 34px;
  min-height: 0;
}

:deep(.v-field__prepend-inner) {
  padding-left: 5px;
}
</style>